import { useEffect, useState } from "react";
import { SignaturePad } from "./Commons/SignaturePad";
import { FormToAddService } from "./Commons/FormToAddService";
import useServicesStore from "../store/servicesStore";
import { MagnifyingGlass, ThreeDots } from "react-loader-spinner";
import "./styles.css";
import { useCustomerOptions } from "../hooks/useCustomerOptions";
import AuthenticationModal from "./Commons/AuthenticationModal";
import { InputName } from "./Commons/InputName";
import { IS_NEW, IS_REGISTERED } from "../constants/form";
import { handleSubmit } from "./handleSubmit";
import Swal from "sweetalert2";

export const Form = () => {
  const [customer, setCustomer] = useState("");
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [customerType, setCustomerType] = useState(IS_REGISTERED);
  const [signature, setSignature] = useState();

  const { customerOptions, loadingCustomer, getCustomerOptions } =
    useCustomerOptions();
  const { total, services, clearService } = useServicesStore();

  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  const handleRadioClick = (value) => {
    setCustomerType(value);
    if (value === 'new') {
      handleShow();
    }
  };

  useEffect(() => {
    customerOptions.length === 1 && setCustomer(customerOptions[0]);
  }, [customerOptions]);

  const onSubmit = (e) => {
    e.preventDefault();
      Swal.fire({
        title: "Enviar copia de remisión",
        text: "Escriba el correo electrónico donde se enviara la remisión",
        input: 'email',
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          try{
            customer.emailToSend = Swal.getInput()?.value || ''
            await handleSubmit(total, customer, services, customerType, clearService, signature, setLoading, setCustomer)
            setCustomerType(IS_REGISTERED)
            setSignature(false)

          } catch(e){
            console.log("customer catch", customer)
            console.log("e", e)
          }
          
        },
      })
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCustomer((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  console.log("customer", customer)

  return (
    <>
      <div className="App">
        <div className="wrapper">
          {/* Modal crear */}
          <div
            className="modal fade bd-example-modal-lg show d-block"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="modalCrearUsuario"
            aria-hidden="true"
            id="ModalCrudUsuario"
            style={{ overflowX: "hidden", overflowY: "auto" }}
          >
            <div className="modal-dialog modal-lg">
              <div className="modal-content">
                <div className="modal-header bg-light">
                  <h4 className="modal-title">
                    <strong>Registrar remisión</strong>
                  </h4>
                </div>
                <div className="modal-body pt-4">
                  <form id="btnsubmit" method="POST" onSubmit={onSubmit}>
                    <div id="BodyCrudUno">
                      <div className="alert-info text-justify pl-3 pr-3 pt-1"></div>
                      <hr />
                      <div className="text-center">
                        <span className="panel-title">
                          <strong>Datos del cliente</strong>
                        </span>
                        <br />
                        <br />
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-md-6 pl-3 pr-3">
                          <div class="form-check">
                            <input 
                              className="form-check-input"  
                              type="radio" 
                              name="customerType" 
                              id="registered" 
                              value="registered"
                              onClick={()=>handleRadioClick(IS_REGISTERED)}
                              checked={customerType === IS_REGISTERED}/> 
                            Cliente Registrado
                          </div>
                        </div>
                        <div className="col-md-6 pl-3 pr-3">
                          <div className="form-group">
                            <div class="form-check">
                              <input 
                                className="form-check-input" 
                                type="radio" 
                                name="customerType" 
                                id="new" 
                                value="new"
                                onClick={()=>handleRadioClick(IS_NEW)}
                                checked={customerType === IS_NEW}
                              /> 
                              Cliente Nuevo (requiere autenticación)
                            </div>
                          </div>
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-md-6 pl-3 pr-3">
                          <div className="input-group mb-3">
                            <div className="input-group-append input-group-text rounded-0 rounded-right">
                              <span className="far fa-id-card"></span>
                            </div>
                            {loadingCustomer ? (
                              <div className="form-control text-center">
                                <MagnifyingGlass
                                  width="30"
                                  height="30"
                                  wrapperStyle={{ display: "inline" }}
                                />
                              </div>
                            ) : (
                              <input
                                value={customer?.identification || ""}
                                onChange={(e) =>
                                  setCustomer((prev) => ({
                                    ...prev,
                                    identification: e.target.value,
                                  }))
                                
                                }
                                type="search"
                                className="form-control"
                                name="customerIdentification"
                                id="customerIdentification"
                                autoComplete="off"
                                placeholder="Identificación"
                                onBlur={(e) =>
                                  getCustomerOptions(
                                    `identification=${e.target.value}`
                                  )
                                }
                                required
                              />
                            )}
                          </div>
                        </div>
                        <div className="col-md-6 pl-3 pr-3">
                          <div className="input--name input-group mb-3">
                            <div className="input-group-append input-group-text rounded-0 rounded-right">
                              <span className="fas fa-user"></span>
                            </div>
                            {loadingCustomer ? (
                              <div className="form-control text-center">
                                <MagnifyingGlass
                                  width="30"
                                  height="30"
                                  wrapperStyle={{ display: "inline" }}
                                />
                              </div>
                            ) : (
                              <InputName 
                                customer={customer} 
                                setCustomer={setCustomer} 
                                customerOptions={customerOptions}
                                customerType={customerType}/>
                            )}
                          </div>
                        </div>
                        <div className="col-md-6 pl-3 pr-3">
                          <div className="input-group mb-3">
                            <div className="input-group-append input-group-text rounded-0 rounded-right">
                              <span className="fas fa-at"></span>
                            </div>
                            {loadingCustomer ? (
                              <div className="form-control text-center">
                                <MagnifyingGlass
                                  width="30"
                                  height="30"
                                  wrapperStyle={{ display: "inline" }}
                                />
                              </div>
                            ) : (
                              <input
                                value={customer?.contacts?.[0]?.email  || ""}
                                onChange={(e) =>
                                  setCustomer((prev) => ({
                                    ...prev,
                                    contacts: [{ ...prev.contacts?.[0], email: e.target.value }],
                                  }))
                                }
                                type="email"
                                className="form-control"
                                name="customerEmail"
                                id="customerEmail"
                                autoComplete="off"
                                placeholder="Correo"
                                disabled={customerType === IS_REGISTERED}
                                required
                              />
                            )}
                          </div>
                        </div>
                        <div className="col-md-6 pl-3 pr-3">
                          <div className="input-group mb-3">
                            <div className="input-group-append input-group-text rounded-0 rounded-right">
                              <span className="fas fa-phone-alt"></span>
                            </div>
                            {loadingCustomer ? (
                              <div className="form-control text-center">
                                <MagnifyingGlass
                                  width="30"
                                  height="30"
                                  wrapperStyle={{ display: "inline" }}
                                />
                              </div>
                            ) : (
                              <input
                                value={customer?.phones?.[0]?.number  || ""}
                                onChange={(e) =>
                                  setCustomer((prev) => ({
                                    ...prev,
                                    phones: [{ ...prev.phones?.[0], number: e.target.value }],
                                  }))
                                }
                                type="number"
                                className="form-control"
                                name="customerPhone"
                                id="customerPhone"
                                autoComplete="off"
                                placeholder="Teléfono"
                                disabled={customerType === IS_REGISTERED}
                                required
                              />
                            )}
                          </div>
                        </div>
                      </div>

                      <hr />

                      <FormToAddService />
                    </div>

                    <div className="text-center" id="BodyCrudCanvas">
                      <SignaturePad setSignature={setSignature} signature={signature} />
                    </div>

                    <div className="modal-footer justify-content-between">
                      <button
                        type="submit"
                        className="btn btn-success btn-block"
                        id="guardarFormulario"
                        disabled={loading}
                      >
                        {loading ? (
                          <ThreeDots
                            color="white"
                            width="20"
                            height="20"
                            ariaLabel="watch-loading"
                            wrapperStyle={{ display: "inline" }}
                          />
                        ) : (
                          "Guardar"
                        )}
                      </button>
                    </div>
                    <br />
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <AuthenticationModal show={showModal} handleClose={handleClose} setCustomerType={setCustomerType} />
      </div>
    </>
  );
};
